import { Controller } from "@hotwired/stimulus";
import querystring from "querystring";
import axios from "axios";

export default class extends Controller {
  static targets = ["form", "input", "submit", "reset", "search"];

  connect() {
    for (const i in this.inputTargets) {
      const input = this.inputTargets[i];
      switch (input.type) {
        case "select":
          input.selectedIndex = 0;
          break;
        default:
          input.value = "";
          break;
      }
    }

    this.filter();

    this.submitTarget.classList.add("visually-hidden");
    this.submitTarget.setAttribute("aria-hidden", "true");
    this.submitTarget.tabIndex = -1;
  }

  searchSubmit(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    this.filter();
    return false;
  }

  getResults(filters, page) {
    const params = Object.assign({ page: page }, filters);
    if (this.hasSearchTarget) {
      const q = this.searchTarget.value.trim();
      if (q) {
        params.q = q;
      }
    }
    const output = document.querySelector(this.data.get("output"));
    const paginator = document.querySelector(this.data.get("paginator"));

    axios
      .get(this.data.get("url"), {
        params,
        responseType: "text",
        paramsSerializer: (params) => querystring.stringify(params),
      })
      .then(function (response) {
        if (page > 1) {
          paginator.remove();
          const currentItems = output.innerHTML;
          output.innerHTML = currentItems + response.data;
        } else {
          output.innerHTML = response.data;
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  getOptions() {
    const params = {};
    this.inputTargets.forEach((input) => {
      Object.assign(params, { [input.name]: input.value });
    });
    this.toggleResetButton(this._filtersDirty());
    return params;
  }

  _filtersDirty() {
    const inputsDirty = this.inputTargets.some((input) => this._isInputDirty(input));
    const searchDirty =
      this.hasSearchTarget && this.searchTarget.value.trim() !== "";
    return inputsDirty || searchDirty;
  }

  toggleResetButton(selected) {
    this.resetTarget.classList.toggle("visually-hidden", !selected);
    if (selected) {
      this.resetTarget.tabIndex = 0;
      this.resetTarget.setAttribute("aria-hidden", "false");
    } else {
      this.resetTarget.tabIndex = -1;
      this.resetTarget.setAttribute("aria-hidden", "true");
    }
  }

  filter() {
    this.getResults(this.getOptions(), 1);
  }

  loadMore(e) {
    e.preventDefault();
    this.getResults(this.getOptions(), e.currentTarget.dataset.page);
  }

  _isInputDirty(el) {
    let input = el;
    if (input !== null) {
      switch (input.type) {
        case "select":
          return input.selectedIndex > 0;
        default:
          return input.value !== "";
      }
    }
  }
}
